import { FaExternalLinkAlt, FaGithub } from "react-icons/fa";


const ProjectCard = ({ project }) => {
    return (
        <article className="group flex h-full flex-col rounded-lg border border-slate-200 bg-white p-6 shadow-sm transition duration-300 hover:-translate-y-1 hover:border-blue-200 hover:shadow-xl dark:border-slate-700 dark:bg-slate-800 dark:hover:border-blue-900 sm:p-8">
            <h2 className="mb-3 text-2xl font-bold leading-tight text-slate-950 dark:text-white sm:text-3xl">
                {project.name}
            </h2>

            <p className="mb-5 text-sm text-slate-500 dark:text-slate-400">
                {project.updated_at}
            </p>

            {project.topics && project.topics.length > 0 && (
                <div className="mb-6 flex flex-wrap gap-2">
                    {project.topics.map((topic, index) => (
                        <span
                            key={index}
                            className="rounded-md border border-slate-200 bg-slate-50 px-2.5 py-1 text-xs font-medium text-slate-600 dark:border-slate-600 dark:bg-slate-700 dark:text-slate-300 sm:text-sm"
                        >
                            {topic}
                        </span>
                    ))}
                </div>
            )}

            {project.description && (
                <p className="mb-6 flex-grow text-sm leading-relaxed text-slate-700 dark:text-slate-300 sm:text-base">
                    {project.description}
                </p>
            )}

            <div className="flex flex-wrap gap-x-6 gap-y-3 border-t border-slate-200 pt-5 dark:border-slate-700">
                {project.html_url && (
                    <a
                        href={project.html_url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-2 font-semibold text-blue-700 transition-colors hover:text-blue-900 hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-blue-600 dark:text-blue-300 dark:hover:text-blue-200 dark:focus-visible:outline-blue-300"
                    >
                        <FaGithub className="text-lg" aria-hidden="true" />
                        View Source
                    </a>
                )}
                {project.homepage && (
                    <a
                        href={project.homepage}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-2 font-semibold text-blue-700 transition-colors hover:text-blue-900 hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-blue-600 dark:text-blue-300 dark:hover:text-blue-200 dark:focus-visible:outline-blue-300"
                    >
                        <FaExternalLinkAlt className="text-lg" aria-hidden="true" />
                        Live Demo
                    </a>
                )}
            </div>
        </article>
    );
};

export default ProjectCard;